// extracted by mini-css-extract-plugin
export default {"main":"styles_main__9T+gx","mainImg":"styles_mainImg__tU0nc"};